import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckIcon from '@mui/icons-material/Check';
import styles from "./DropdownMenu.module.css";

function DropdownMenu(props) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const options = [
  //   "Quranic Arabic Language Level-01 (Sisters Only)",
  //   "Atria",
  //   "Callisto",
  //   "Dione",
  //   "Ganymede",
  //   "Hangouts Call",
  //   "Luna",
  //   "Oberon",
  //   "Phobos",
  //   "Pyxis",
  //   "Sedna",
  //   "Titania",
  //   "Triton",
  //   "Umbriel",
  // ];

  return (
    <div className={styles.DropdownMenuContainer}>
      <div>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            paper: {
              style: {
                maxHeight: "400px",
              },
            },
          }}
          className={styles.DropdownMenu}
        >
          {props.options.map((option) => (
            <MenuItem
              key={option.key}
              selected={option === props.selected}
              onClick={(e) => {
                handleClose()
                option.onChange()
              }}
            // onChange={(e) =>option.onChange()}
            
            >
              <div style={{display:'flex', gap:"8px", alignItems:'center',}}>
              {option.Icon}{option.label}
              </div>
              <div className="MenuCheckIcon">
                <CheckIcon />
              </div>
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  );
}

export default DropdownMenu;
